import { render, staticRenderFns } from "./12.vue?vue&type=template&id=bda64d82&scoped=true"
import script from "./12.vue?vue&type=script&lang=js"
export * from "./12.vue?vue&type=script&lang=js"
import style0 from "./12.vue?vue&type=style&index=0&id=bda64d82&prod&lang=less&scoped=true"
import style1 from "./12.vue?vue&type=style&index=1&id=bda64d82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda64d82",
  null
  
)

export default component.exports